import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "src/dm/utils/axios";
import { APIS } from "src/dm/utils/constants";
import {
  CreateDealNoteRequest,
  DealNote,
} from "src/dm/interfaces/DealNote";

const notesUrl = (dealId: number) => `${APIS.Deals}/${dealId}/notes`;

interface NotesResponse {
  items: DealNote[];
  total: number;
}

export const useDealNotes = (dealId: number | undefined) =>
  useQuery({
    queryKey: ["deal-notes", dealId],
    enabled: dealId !== undefined && dealId > 0,
    queryFn: async (): Promise<DealNote[]> => {
      const response = await apiClient.get<NotesResponse>(notesUrl(dealId as number));
      return response.data.items;
    },
  });

export const useAddDealNote = (dealId: number) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: CreateDealNoteRequest): Promise<DealNote> => {
      const response = await apiClient.post<DealNote>(notesUrl(dealId), body);
      return response.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["deal-notes", dealId] });
      qc.invalidateQueries({ queryKey: ["deal", dealId] });
    },
  });
};
